module.exports = __webpack_public_path__ + "img/Icon_add_evaluation.96eb9e76.svg";